import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';

const TermsOfService = () => {
    return (
        <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 } }}>
            <Paper
                elevation={6}
                sx={{
                    p: { xs: 3, md: 6 },
                    background: 'rgba(20, 20, 24, 0.95)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(139, 92, 246, 0.25)',
                    boxShadow: '0 20px 50px rgba(0, 0, 0, 0.8), 0 0 25px rgba(139, 92, 246, 0.15)',
                    borderRadius: 4,
                    color: '#fff',
                }}
            >
                <Typography
                    variant="h3"
                    component="h1"
                    gutterBottom
                    sx={{
                        fontFamily: 'Orbitron, sans-serif',
                        fontWeight: 700,
                        fontSize: { xs: '1.8rem', md: '2.4rem' },
                        background: 'linear-gradient(45deg, #00D4FF, #8B5CF6, #FF0099)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        mb: 3,
                    }}
                >
                    Termos de Serviço
                </Typography>

                <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.5)', display: 'block', mb: 3 }}>
                    Última atualização: Setembro de 2026
                </Typography>

                <Box sx={{ opacity: 0.95, lineHeight: 1.8, fontSize: '0.95rem' }}>
                    <Typography variant="body1" paragraph>
                        Bem-vindo à <strong>NostalBeat</strong>! Ao acessar ou utilizar nossa plataforma web de streaming de rádio, transmissões ao vivo e mural de comentários disponível em <a href="https://nostalbeat.com.br" style={{ color: '#00D4FF' }}>nostalbeat.com.br</a>, você concorda em cumprir e vincular-se a estes Termos de Serviço. Caso não concorde com algum dos termos descritos, solicitamos que não utilize nossos serviços.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#00D4FF', mt: 4 }}>
                        1. Descrição dos Serviços
                    </Typography>
                    <Typography variant="body1" paragraph>
                        A NostalBeat é uma estação de rádio online focada em entretenimento musical, oferecendo transmissões ao vivo de DJs, programações temáticas das décadas de 80, 90 e 2000, além de um espaço comunitário para ouvintes interagirem através de comentários.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#8B5CF6', mt: 4 }}>
                        2. Uso Aceitável e Código de Conduta no Mural de Comentários
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Para manter um ambiente saudável, respeitoso e acolhedor para todos os ouvintes, você concorda em <strong>não</strong> publicar ou disseminar:
                    </Typography>
                    <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                        <li><Typography variant="body2" sx={{ mb: 1 }}>Mensagens de ódio, discriminação racial, religiosa, de gênero ou sexual;</Typography></li>
                        <li><Typography variant="body2" sx={{ mb: 1 }}>Conteúdo ofensivo, difamatório, ameaçador, pornográfico ou ilegal;</Typography></li>
                        <li><Typography variant="body2" sx={{ mb: 1 }}>Spam, correntes, publicidade não autorizada ou divulgação de links maliciosos;</Typography></li>
                        <li><Typography variant="body2" sx={{ mb: 1 }}>Tentativas de se passar por DJs, moderadores ou administradores da rádio.</Typography></li>
                    </Box>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                        A moderação da NostalBeat reserva-se o direito de remover qualquer comentário que viole estas diretrizes, bem como suspender ou restringir o acesso de usuários reincidentes.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#FF0099', mt: 4 }}>
                        3. Autenticação e Contas de Usuário (Google Sign-In)
                    </Typography>
                    <Typography variant="body1" paragraph>
                        A participação no mural de comentários é viabilizada através do serviço oficial Google Identity Services (OAuth 2.0). Ao efetuar login com sua conta Google, você é responsável pela segurança de suas credenciais de acesso Google e pela veracidade das manifestações realizadas em seu nome na plataforma.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#00D4FF', mt: 4 }}>
                        4. Propriedade Intelectual
                    </Typography>
                    <Typography variant="body1" paragraph>
                        A marca NostalBeat, identidade visual, logotipos, layout do site e elementos gráficos são de propriedade exclusiva da NostalBeat. As músicas transmitidas na programação radiofônica são executadas para fins culturais e de entretenimento, respeitando os direitos autorais de seus respectivos compositores e intérpretes.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#8B5CF6', mt: 4 }}>
                        5. Limitação de Responsabilidade
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Embora nos esforcemos para manter a rádio no ar 24 horas por dia, 7 dias por semana, a NostalBeat não garante que o serviço de streaming ou o site funcionarão de forma ininterrupta ou isenta de falhas decorrentes de instabilidades na internet, servidores terceiros ou manutenções técnicas.
                    </Typography>

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#FF0099', mt: 4 }}>
                        6. Alterações nos Termos
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Podemos revisar e atualizar estes Termos de Serviço periodicamente. O uso contínuo da plataforma após a publicação de quaisquer alterações constituirá sua aceitação dos novos termos.
                    </Typography>

                    <Divider sx={{ my: 4, bgcolor: 'rgba(255,255,255,0.1)' }} />

                    <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Orbitron', color: '#00D4FF' }}>
                        7. Contato
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Para esclarecimentos, dúvidas ou reporte de irregularidades sobre nossos Termos de Serviço, visite nosso portal: <a href="https://nostalbeat.com.br" style={{ color: '#00D4FF' }}>https://nostalbeat.com.br</a>.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default TermsOfService;
